/*
 * skiModel.js
 * Ski Model for RSWebJS
 */

define( 'app/models/skiModel',['rsweblib','app/ModelClass','underscore'], function( rs, ModelClass, _ ){
    var weekDays = { 0: "Sunday", 1: "Monday", 2: "Tuesday", 3: "Wednesday", 4: "Thursday", 5: "Friday", 6: "Saturday" }
    function parseSkiItemDates (item,skiDate) {
        item.price = (Customization.skiBooking.showPriceIncludingSurcharges && item.PriceWithSurcharges)
                        ? item.PriceWithSurcharges : item.Price;
        if (item.StartDate && item.EndDate && Date.parse(item.StartDate.substr(0,10), 'yyyy-MM-dd') && Date.parse(item.EndDate.substr(0,10), 'yyyy-MM-dd')) {
            item.earliestStartDate = skiDate < Date.parse( item.StartDate.substr(0,10), 'yyyy-MM-dd' ) ? item.StartDate : skiDate.toString('yyyy-MM-dd') + '000000';
            var esd = Date.parse(item.earliestStartDate.substr(0,10), 'yyyy-MM-dd'),
                ed = Date.parse(item.EndDate.substr(0,10), 'yyyy-MM-dd').add(-1).days();
            while (item["Avail"+weekDays[esd.getDay()]] != "Y" && esd<ed) {
                esd.add(1).day();
            }
            if (esd>=ed) return; // There is no day on which the pass can be used before the end date.
            var eed = +item.DurationDays
                        ? ( esd.clone().add(+item.DurationDays-1).days()>ed ? ed : esd.clone().add(+item.DurationDays-1).days() )
                        : ed;
            item.earliestStartDate = esd.toString('yyyy-MM-dd')  + '000000';
            item.effectiveEndDate = eed.toString('yyyy-MM-dd')  + '000000';
        } else {
            item.earliestStartDate = skiDate.toString('yyyy-MM-dd') + '000000';
        }
    }
    return window.app.models.skiModel = $.extend({}, ModelClass, {

            app: app,

            module: 'ski',

            dataModel: {
                'skiLocations' : {
                    source: {'soap':'FetchSkiLocations', 'ns':'k'},
                    parameters: [{name:'WebFolioId', model:'system.createSession.WebFolioId'}],
                    returnData: [{name:'SkiLocation', array: true, key:"LocationId"}],
                    fetchOnce: true,
                    persistData: false,
                    persistSelection: true
                },
                'skiItemsRaw' : {
                    source: {'soap':'FetchSkiItems','ns':'k'},
                    parameters: [
                        {name:'Location',model:'ski.skiLocations.LocationId'},
                        {name:'WebFolioId', model:'system.createSession.WebFolioId'},
                        {name:'CustomerId', userinput:true, optional:true},
                        {name:'StartDate', userinput:true, optional:true},
                        {name:'EndDate', userinput:true, optional:true}
                        ],
                    returnData: [
                        {name:'Result', key:"value"},
                        {name:'LiftTickets', key:"LiftTicket.SkiItemId"},
                        {name:'PromoLiftTickets', key:"PromoLiftTicket.SkiItemId"},
                        {name:'Passes', key:"Pass.SkiItemId"},
                        {name:'PromoPasses', key:"PromoPass.SkiItemId"},
                        {name:'Rentals', key:"Rental.SkiItemId"},
                        {name:'PromoRentals', key:"PromoRental.SkiItemId"},
                        {name:'Packages', key:"Package.SkiItemId"},
                        {name:'PromoPackages', key:"PromoPackage.SkiItemId"},
                        {name:'Programs', key:"Program.SkiItemId"},
                        {name:'PromoPrograms', key:"PromoProgram.SkiItemId"},
                        {name:'InsuranceItems', key:"InsuranceItem.SkiItemId"}
                        ],
                    fetchOnce: false,
                    persistData: false,
                    persistSelection: true
                },
                'skiItems' : {
                    source: {'model':'ski.skiItemsRaw',mapper:function(thisModel,sourceModelName,parameters,r){
                        r.typeById={}
                        r.subTypeById={}
                        _.each([
                            ['LiftTickets','LiftTicket'],
                            ['PromoLiftTickets','LiftTicket'],
                            ['Passes','Pass'],
                            ['PromoPasses','Pass'],
                            ['Programs','Program'],
                            ['PromoPrograms','Program'],
                            ['Packages','Package'],
                            ['PromoPackages','Package'],
                            ['Rentals','Rental'],
                            ['PromoRentals','Rental'],
                            ['InsuranceItems','InsuranceItem'],
                            ], function(x){
                                if (r[x[0]] && r[x[0]][x[1]]) {
                                    r[x[0]][x[1]] = $.wrapArray(r[x[0]][x[1]])
                                    _.each(r[x[0]][x[1]],function(y){
                                        parseSkiItemDates(y, Date.parse( parameters.StartDate.substr(0,10), 'yyyy-MM-dd' ));
                                        y.type=x[1];
                                        r.typeById[y.SkiItemId]=x[0];
                                        r.subTypeById[y.SkiItemId]=x[1];
                                    })
                                }
                            })
                        return r
                    }},
                    parameters: [
                        {name:'Location',model:'ski.skiLocations.LocationId'},
                        {name:'WebFolioId', model:'system.createSession.WebFolioId'},
                        {name:'CustomerId', userinput:true, optional:true},
                        {name:'StartDate', userinput:true, optional:true},
                        {name:'EndDate', userinput:true, optional:true}
                        ],
                    returnData: [
                        {name:'Result', key:"value"},
                        {name:'LiftTickets', key:"LiftTicket.SkiItemId"},
                        {name:'PromoLiftTickets', key:"PromoLiftTicket.SkiItemId"},
                        {name:'Passes', key:"Pass.SkiItemId"},
                        {name:'PromoPasses', key:"PromoPass.SkiItemId"},
                        {name:'Rentals', key:"Rental.SkiItemId"},
                        {name:'PromoRentals', key:"PromoRental.SkiItemId"},
                        {name:'Packages', key:"Package.SkiItemId"},
                        {name:'PromoPackages', key:"PromoPackage.SkiItemId"},
                        {name:'Programs', key:"Program.SkiItemId"},
                        {name:'PromoPrograms', key:"PromoProgram.SkiItemId"},
                        {name:'InsuranceItems', key:"InsuranceItem.SkiItemId"}
                        ],
                    fetchOnce: false,
                    persistData: false,
                    persistSelection: true
                },

                'skiLiftTickets' : {
                    source: {'soap':'FetchSkiLiftTickets','ns':'k'},
                    parameters: [
                        {name:'Location',model:'ski.skiLocations.LocationId'},
                        {name:'WebFolioId', model:'system.createSession.WebFolioId'},
                        {name:'CustomerId', userinput:true, optional:true},
                        {name:'StartDate', userinput:true, optional:true},
                        {name:'EndDate', userinput:true, optional:true}
                        ],
                    returnData: [
                        {name:'Result', key:"value"},
                        {name:'LiftTickets', key:"SkiItemId"},
                        {name:'PromoLiftTickets', key:"SkiItemId"}
                        ],
                    fetchOnce: false,
                    persistData: false,
                    persistSelection: true
                },
                'skiPasses' : {
                    source: {'soap':'FetchSkiPasses','ns':'k'},
                    parameters: [
                        {name:'Location',model:'ski.skiLocations.LocationId'},
                        {name:'WebFolioId', model:'system.createSession.WebFolioId'},
                        {name:'CustomerId', userinput:true, optional:true},
                        {name:'StartDate', userinput:true, optional:true},
                        {name:'EndDate', userinput:true, optional:true}
                        ],
                    returnData: [
                        {name:'Result', key:"value"},
                        {name:'Passes', key:"Pass.SkiItemId"},
                        {name:'PromoPasses', key:"PromoPass.SkiItemId"}
                        ],
                    fetchOnce: false,
                    persistData: false,
                    persistSelection: true
                },
                'purchaseSkiItem' : {
                    source: {'soap':'PurchaseSkiItem', 'ns':'k' },
                    parameters: [
                        {name:'SessionId', model:'system.createSession.SessionId'},
                        {name:'WebFolioId', model:'system.createSession.WebFolioId'},
                        {name:'CustomerId', userinput:true, optional:true},
                        {name:'SkiItemId', model:'ski.skiItems.SkiItemId'},
                        {name:'StartDate', userinput:true, optional:true},
                        {name:'WTPNo', userinput:true, optional:true},
                        {name:'Qty', userinput:true},
                        {name:'GuestRequest', userinput:true, optional:true},
                        {name:'SkiPackage.PackageItem.WTPNo', userinput:true, optional:true},
                        {name:'SkiPackage.PackageItem.CustomerId', userinput:true, optional:true},
                        {name:'SkiPackage.PackageItem.GuestRequest', userinput:true, optional:true}
                        
                    ],
                    returnData: [
                        {name:'SkiFolioId', key:'SkiFolioId'},
                        {name:'SkiFolioItemId', key:'SkiFolioItemId'}
                    ],
                    fetchOnce: false,
                    persistData: false,
                    persistSelection: false
                },
                'purchaseSkiLiftTicket' : {
                    source: {'soap':'PurchaseSkiLiftTicket', 'ns':'k' },
                    parameters: [
                        {name:'SessionId', model:'system.createSession.SessionId'},
                        {name:'WebFolioId', model:'system.createSession.WebFolioId'},
                        {name:'CustomerId', userinput:true, optional:true},
                        {name:'SkiItemId', model:'ski.skiLiftTickets.SkiItemId'},
                        {name:'StartDate', userinput:true, optional:true},
                        {name:'Qty', userinput:true}
                    ],
                    returnData: [
                        {name:'SkiFolioId', key:'SkiFolioId'},
                        {name:'SkiFolioItemId', key:'SkiFolioItemId'}
                    ],
                    fetchOnce: false,
                    persistData: false,
                    persistSelection: false
                },
                'purchaseSkiPass' : {
                    source: {'soap':'PurchaseSkiPass', 'ns':'k' },
                    parameters: [
                        {name:'SessionId', model:'system.createSession.SessionId'},
                        {name:'WebFolioId', model:'system.createSession.WebFolioId'},
                        {name:'CustomerId', userinput:true, optional:true},
                        {name:'SkiItemId', model:'ski.skiPasses.Pass.SkiItemId'},
                        {name:'StartDate', userinput:true, optional:true}
                    ],
                    returnData: [
                        {name:'SkiFolioId', key:'SkiFolioId'},
                        {name:'SkiFolioItemId', key:'SkiFolioItemId'}
                    ],
                    fetchOnce: false,
                    persistData: false,
                    persistSelection: false
                }
            }
        })
});

